import { jsx } from "react/jsx-runtime";
import { HttpClientContext, PanoramaContext, TranslationContext, ScrollProvider, FocusedFieldProvider, FieldInitialDataContext, BiContext, ExternalDataProvider, ConfigContextProvider, ForcedStateContext, FormContext, AddressFormsContext, getAddressForm, ExperimentsContext, EventsProvider, WixRicosViewerContext } from "@wix/form-fields";
import { useMemo, useContext } from "react";
import { SubmitStatusProvider } from "../../contexts/submit-status-context.js";
import { HostContext } from "../../tpa/widget/host-context.js";
import { useFormBi } from "../form/use-form-bi.js";
const FormViewerProvider = ({
  i18n,
  bi,
  biFormFillSessionId,
  form,
  isMobile,
  isEditor,
  isComposer,
  isRTL,
  compId,
  language,
  regionalFormat,
  externalData,
  forcedState,
  instance,
  children,
  httpClient,
  panorama,
  experiments,
  translationNamespace,
  currency,
  userData,
  WixRicosViewer,
  addressTemplates,
  atlasBaseUrl,
  fieldInitialData,
  enableAnimations,
  baseUrl
}) => {
  const translations = useMemo(
    () => ({
      t: i18n.getFixedT(language, translationNamespace),
      i18n
    }),
    [language, i18n, translationNamespace]
  );
  const formBi = useFormBi(form, bi, biFormFillSessionId);
  const host = useContext(HostContext) ?? {};
  const config = useMemo(
    () => ({
      language,
      regionalFormat,
      instance,
      isMobile,
      currency,
      atlasBaseUrl,
      userData,
      compId,
      baseUrl,
      isEditor,
      isComposer,
      isRTL,
      enableAnimations,
      style: host?.style
    }),
    [
      language,
      regionalFormat,
      instance,
      isMobile,
      currency,
      atlasBaseUrl,
      userData,
      compId,
      baseUrl,
      isEditor,
      isComposer,
      isRTL,
      enableAnimations,
      host?.style
    ]
  );
  const forcedViewState = useMemo(() => forcedState ?? [], [forcedState]);
  return /* @__PURE__ */ jsx(HttpClientContext.Provider, { value: { httpClient }, children: /* @__PURE__ */ jsx(PanoramaContext.Provider, { value: { panorama }, children: /* @__PURE__ */ jsx(TranslationContext.Provider, { value: translations, children: /* @__PURE__ */ jsx(ScrollProvider, { children: /* @__PURE__ */ jsx(FocusedFieldProvider, { children: /* @__PURE__ */ jsx(FieldInitialDataContext.Provider, { value: fieldInitialData, children: /* @__PURE__ */ jsx(BiContext.Provider, { value: formBi, children: /* @__PURE__ */ jsx(ExternalDataProvider, { externalData, children: /* @__PURE__ */ jsx(ConfigContextProvider, { value: config, children: /* @__PURE__ */ jsx(ForcedStateContext.Provider, { value: forcedViewState, children: /* @__PURE__ */ jsx(FormContext.Provider, { value: form, children: /* @__PURE__ */ jsx(
    AddressFormsContext.Provider,
    {
      value: {
        getCountryAddressForm: (country) => getAddressForm(addressTemplates, country),
        addressTemplates
      },
      children: /* @__PURE__ */ jsx(ExperimentsContext.Provider, { value: experiments, children: /* @__PURE__ */ jsx(EventsProvider, { children: /* @__PURE__ */ jsx(
        WixRicosViewerContext.Provider,
        {
          value: WixRicosViewer,
          children: /* @__PURE__ */ jsx(SubmitStatusProvider, { children })
        }
      ) }) })
    }
  ) }) }) }) }) }) }) }) }) }) }) });
};
export {
  FormViewerProvider
};
//# sourceMappingURL=form-viewer-provider.js.map
